'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Storage = require('./Storage');

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEBUG_FLAG = 'FIREALARM_DEBUG';

var storage = void 0;
try {
  var localStorage = window && window.localStorage ? window.localStorage : false;
  storage = new _Storage2.default(localStorage);
} catch (e) {
  storage = new _Storage2.default(false);
}

function debug(message) {
  if (storage.getItem(DEBUG_FLAG)) {
    console.log.apply(console, arguments);
  }
}

exports.default = debug;
module.exports = exports['default'];